import { render, staticRenderFns } from "./text-block.vue?vue&type=template&id=750f43de&"
import script from "./text-block.vue?vue&type=script&lang=js&"
export * from "./text-block.vue?vue&type=script&lang=js&"
import style0 from "./text-block.vue?vue&type=style&index=0&id=750f43de&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports